import API_ENDPOINTS from '../api/endpoints';
import apiClient from "../api/apiClient";

/**
 * Send a message to ServSpace AI
 * @param {Object} payload
 * @param {string} payload.message - User message
 * @param {Array} payload.history - (optional) chat history
 */
export const sendChatMessage = async ({ message, history = [] }) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.CHAT.MESSAGE, {
      message,
      history,
    });

    return response.data;
  } catch (error) {
    console.error("Chat message failed:", error);
    throw error;
  }
};

/**
 * Freelancer / Business AI (leads & requests)
 */
export const sendServiceProviderChatMessage = async ({ message, history = [] }) => {
  const response = await apiClient.post(
    API_ENDPOINTS.CHAT.SERVICE_PROVIDER,
    { message, history }
  );
  return response.data;
};